"use client";

import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Link } from "@/components/common/Link";
const platforms = [{
  id: 1,
  name: "Facebook",
  icon: Facebook,
  description: "Build community and drive engagement on Facebook",
  color: "bg-[#1877F2]"
}, {
  id: 2,
  name: "Instagram",
  icon: Instagram,
  description: "Share visual stories and connect with your audience",
  color: "bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF]"
}, {
  id: 3,
  name: "LinkedIn",
  icon: Linkedin,
  description: "Establish professional credibility and network",
  color: "bg-[#0A66C2]"
}];
export default function EngageAndGrowYourAudienceOnSocialMedia() {
  return <section className="relative min-h-[600px] overflow-hidden bg-gradient-to-br from-primary-100 via-secondary-100 to-accent-light py-20 px-4">
      <div className="mx-auto max-w-6xl">
        <div className="mb-16 text-center space-y-4">
          <h2 className="text-4xl font-bold font-display tracking-tight text-foreground md:text-5xl leading-tight">
            Engage and Grow Your Audience on Social Media
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-foreground/80 leading-relaxed">
            Connect with your customers across multiple platforms and build lasting relationships
          </p>
        </div>

        <div className="relative flex min-h-[400px] items-center justify-center">
          <div className="grid grid-cols-2 gap-8 md:grid-cols-3 md:gap-12">
            {platforms.map((platform, i) => {
            const Icon = platform.icon;
            const isFacebook = i === 0;
            const isLinkedIn = i === 2;
            const isLinked = isFacebook || isLinkedIn;
            const circleContent = <div data-index={i} className="group relative flex h-32 w-32 cursor-pointer items-center justify-center rounded-full shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-110 hover:shadow-strong focus-ring" style={{
              animation: "rotate 3s linear infinite"
            }} tabIndex={0} role="button" aria-label={`${platform.name} platform`}>
                  <div className={`absolute inset-0 rounded-full ${platform.color} opacity-90 transition-opacity duration-[var(--duration-medium)] group-hover:opacity-100`} />
                  <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 transition-opacity duration-[var(--duration-medium)] group-hover:opacity-100 group-hover:animate-pulse" />
                  <Icon className="relative z-10 h-16 w-16 text-white transition-transform duration-[var(--duration-medium)] group-hover:scale-110" />
                </div>;
            return <Tooltip key={platform.id}>
                  <TooltipTrigger asChild>
                    {isLinked ? <Link to={isFacebook ? "https://www.facebook.com/digitalmarketingsam4u" : "https://www.linkedin.com/company/sambrandmarketing"} newTab className="inline-block">
                        {circleContent}
                      </Link> : circleContent}
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-xs shadow-medium">
                    <p className="font-medium text-sm">{platform.description}</p>
                  </TooltipContent>
                </Tooltip>;
          })}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </section>;
}